const AccessLevel = {
    None: 0,
    Show: 5,
    Edit: 10,
}

export default AccessLevel;
